import { LoggingApi } from '../api-clients';
import { wrap } from '../wrap';

export const loggingApi = {
  log: wrap(LoggingApi, LoggingApi.prototype.log),
};